"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFinalForm = require("react-final-form");

var _form = require("../../form");

var _MarkdownTextarea = _interopRequireDefault(require("../../form/inputs/MarkdownTextarea"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function MarkdownFieldNoPreview(_ref) {
  var label = _ref.label,
      name = _ref.name,
      validate = _ref.validate,
      rows = _ref.rows,
      users = _ref.users;

  function Input(_ref2) {
    var input = _ref2.input,
        meta = _ref2.meta;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
      htmlFor: name,
      style: {
        width: '100%'
      }
    }, label || name), /*#__PURE__*/_react.default.createElement(_form.ErrorWrapper, {
      touched: meta.touched,
      error: meta.error
    }, /*#__PURE__*/_react.default.createElement(_MarkdownTextarea.default, _extends({
      users: users,
      name: name
    }, input, {
      rows: rows,
      resize: "false"
    }))));
  }

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, {
    name: name,
    render: Input,
    validate: validate
  });
}

MarkdownFieldNoPreview.defaultProps = {
  label: undefined,
  rows: 3,
  validate: function validate() {}
};
MarkdownFieldNoPreview.propTypes = {
  label: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  validate: _propTypes.default.func,
  rows: _propTypes.default.number
};
var _default = MarkdownFieldNoPreview;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/comments/CommentForm/MarkdownFieldNoPreview.js
// module id = 812
// module chunks = 0 15 16 17 18